import ComboCombolist from "./combolist";

window.o_combo_combolist = window.o_combo_combolist || [];

export function initCinema() {
	document.querySelectorAll("[id^='combo-sheet-']").forEach(sheet => document.body.appendChild(sheet));

	const containers = document.querySelectorAll(".combo_combolist-container");
	Array.from(containers).forEach(container => {
		if (container.getAttribute("data-tracked") !== "true") {
			container.setAttribute("data-tracked", "true");
			const combolist = new ComboCombolist(container);
			combolist.initCinemaEvents();
			combolist.addClickEventListenersForComboMoodImage();
			combolist.addClickEventListenersForArticles();
			window.o_combo_combolist.push(combolist);
		}
	});
}
